import { render, staticRenderFns } from "./typingRecord.vue?vue&type=template&id=c9c6c7da&scoped=true"
import script from "./typingRecord.vue?vue&type=script&lang=js"
export * from "./typingRecord.vue?vue&type=script&lang=js"
import style0 from "./typingRecord.vue?vue&type=style&index=0&id=c9c6c7da&prod&lamg=less&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9c6c7da",
  null
  
)

export default component.exports